import RouteError from "./RouteError";

/**
 * Error class for routes that are past sale-block time
 */
export default class PastSaleBlockTimeError extends RouteError {
    constructor() {
        super('routePastSaleBlockTime');
    }
}